import { render, staticRenderFns } from "./yingyan.vue?vue&type=template&id=dcbc4a4a&scoped=true"
import script from "./yingyan.vue?vue&type=script&lang=js"
export * from "./yingyan.vue?vue&type=script&lang=js"
import style0 from "./yingyan.vue?vue&type=style&index=0&id=dcbc4a4a&prod&lang=scss&scoped=true"
import style1 from "./yingyan.vue?vue&type=style&index=1&id=dcbc4a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbc4a4a",
  null
  
)

export default component.exports